import { FC } from 'react';

import { BADGE } from '../BadgeIllustration/BadgeIllustration.type';
import { Image } from '@repo/ui/Image';

export const SubscribeFormEnd: FC = () => (
  <div className="mb-6 flex items-center gap-4 rounded-xs bg-for-pri-sub p-4">
    <Image src={BADGE.COMPLETE} alt="" width={56} height={56} className="size-14 object-contain" />
    <div className="flex w-full flex-col gap-1">
      <p className="c-fs-body font-extrabold">Success!</p>
      <p className="c-fs-body2 text-tex-def-tie2">Thanks for subscribing.</p>
    </div>
  </div>
);
